import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'routes.BankCard.AddBankCard.title',
    defaultMessage: 'Add Payment Card',
    description: '备注: 页面title',
  },
  processing: {
    id: 'routes.BankCard.AddBankCard.processing',
    defaultMessage: 'PROCESSING',
    description: '备注: 处理中',
  },
  description: {
    id: 'routes.BankCard.AddBankCard.description',
    defaultMessage: 'This card will be saved after your bank authentication.',
    description: '备注: 处理中提示',
  },
  ok: {
    id: 'routes.BankCard.AddBankCard.ok',
    defaultMessage: 'OK',
    description: '备注: 按钮',
  },
})
